import React, { useEffect, useState } from 'react'
import icondown from '../../assets/images/icons/icon-down.svg'
import { CommonHeadFooter, OriginalPrice, ProdCardDesc, ProdCardName } from '../../StyledComponents';
import { Star } from 'react-feather';
import { Col, Row } from 'reactstrap';
import axios from 'axios';
import { API_URLS } from '../../utility/api/endpoints/endpoints';

const ProductsYouMayLike = (props) => {
  const { down } = props

  const [visibleProducts, setVisibleProducts] = useState(3);

  const [productsYouMayLike, setProductsYouMayLike] = useState([])

  const handleShowMore = () => {
    setVisibleProducts((prev) => prev + 3);
  };

  const fetchProductsYouMayLike = async () => {
    // props.categoryId ||
    try {
      const id = props.categoryId
      const { data } = await axios.get(`${API_URLS.PRODUCTS_YOU_MAY_LIKE}/${id}`)

      if (data.statusCode === 200) {
        setProductsYouMayLike(data.data)
      } else {
        setProductsYouMayLike([])
      }
    } catch (error) {
      console.log("error fetching products you may like: ", error);
    }
  }

  useEffect(() => {

    fetchProductsYouMayLike()

  }, [])


  return (
    <div>
      <div style={{ backgroundColor: '#EC7426', color: 'white', padding: '8px 27px', display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
        PRODUCTS YOU MAY LIKE
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', }}>
        <div style={{ margin: '20px 25px', }}>
          <div style={{ overflowY: 'auto' }}>
            <Row className='m-0'>

              {productsYouMayLike && productsYouMayLike.length === 0 && <div style={{ padding: '20px', textAlign: 'center', color: '#EC7426' }}>
                No products available
              </div>}

              {productsYouMayLike && productsYouMayLike.slice(0, visibleProducts).map((product) => (
                <Col key={product.id} lg='12' md='12' sm='12' xs='12' style={{ height: 'auto', margin: '0', padding: '0' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', }}>
                    {
                      down ?
                        <div style={{ backgroundColor: 'grey', padding: '1rem' }}>
                          <img style={{ maxWidth: "100%", width: "227px", margin: "0 auto" }} src={product.productImages[0]} alt={product.title} />
                        </div>
                        :
                        <img style={{ maxWidth: "100%", width: "227px", margin: "0 auto" }} src={product.productImages[0]} alt={product.title} />

                    }
                    <div style={{ margin: "8px auto 0 auto" }}>
                      <ProdCardName>{product?.title}</ProdCardName>
                      <div style={{ width: '100%', padding: '8px 0 8px 0', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}>
                          <CommonHeadFooter style={{ color: 'orange', fontSize: '18px' }}>${product?.discountedPrice || 0}</CommonHeadFooter> &nbsp;
                          <OriginalPrice><strike>${product?.price || 0}</strike></OriginalPrice>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}>
                          <div><Star size={12} color="orange" fill='orange' /></div> &nbsp;
                          <OriginalPrice>{product?.ratings?.averageRating || 0} ({product?.ratings?.reviewsCount || 0})</OriginalPrice>
                        </div>
                      </div>
                      <ProdCardDesc dangerouslySetInnerHTML={{ __html: product?.productDetails }} />
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          {
            down &&
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img style={{ cursor: 'pointer' }} src={icondown} onClick={handleShowMore} alt="Show more" />
            </div>
          }
        </div>
      </div>

    </div>
  )
}

export default ProductsYouMayLike

{/* {products.slice(0,visibleProducts).map((product) => (
                  <Col key={product.id} lg='12' md='12' sm='12' xs='12' style={{ height: 'auto', margin:'0', padding:'0' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', }}>
                        {
                            down ? 
                                <div style={{backgroundColor:'grey', padding:'1rem'}}>
                                    <img style={{ maxWidth: "100%", width: "227px", margin: "0 auto" }} src={product.image} alt={product.name} />
                                </div>
                                :
                                    <img style={{ maxWidth: "100%", width: "227px", margin: "0 auto" }} src={product.image} alt={product.name} />
                      
                        }
                      <div style={{ margin: "8px auto 0 auto" }}>
                        <ProdCardName>{product.name}</ProdCardName>
                        <div style={{ width: '100%', padding: '8px 0 8px 0', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}>
                            <CommonHeadFooter style={{ color: 'orange', fontSize:'18px' }}>${product.price}</CommonHeadFooter> &nbsp;
                            <OriginalPrice><strike>${product.originalPrice}</strike></OriginalPrice>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}>
                            <div><Star size={12} color="orange" fill='orange' /></div> &nbsp;
                            <OriginalPrice>{product.rating} ({product.reviews})</OriginalPrice>
                          </div>
                        </div>
                        <ProdCardDesc>{product.description}</ProdCardDesc>
                      </div>
                    </div>
                  </Col>
                ))} */}